import { BALL_RADIUS, type Point } from "../shared/engine";

export const HOLE_ANIMATION_MS = 850;

/** Roll across the lip before falling below the cup's visible opening. */
export function holedBallPose(origin: Point, cup: Point, elapsed: number, reducedMotion = false) {
  const progress = reducedMotion ? 1 : Math.max(0, Math.min(1, elapsed / HOLE_ANIMATION_MS));
  const roll = Math.min(1, progress / 0.38);
  const centered = 1 - (1 - roll) ** 2;
  const drop = Math.max(0, (progress - 0.3) / 0.7);
  return {
    x: origin.x + (cup.x - origin.x) * centered,
    y: origin.y + (cup.y - origin.y) * centered,
    height: BALL_RADIUS - drop * drop * (BALL_RADIUS + 30),
    hidden: progress >= 1,
  };
}
